import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Collaboratore, StaticUrls, Messaggio, Profilo } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
//import 'rxjs/Rx';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { Router } from '@angular/router';
import { MyCookieService } from './my-cookie.service';
import { DomSanitizer } from '../../../node_modules/@angular/platform-browser';
import { environment } from 'environments/environment';

@Injectable()
export class CollaboratoreService {

	private collaboratori: Collaboratore[];
	private collaborator: Collaboratore;
	private profili: Profilo[];
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private optionsHeader = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		private sanitizer: DomSanitizer,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private router: Router) { }

	put(candidato: Collaboratore, uploaderCV: FileUploader, uploaderVC: FileUploader): Observable<boolean> {

		return this.http.put(StaticUrls._collaboratore, JSON.stringify(candidato), this.optionsHeader)
			.map((response: Response) => {
				let options: FileUploaderOptions = uploaderCV.options;
				options.url = StaticUrls._cvCandidato(response.text());
				uploaderCV.setOptions(options);
				uploaderCV.uploadAll();

				let optionsVC: FileUploaderOptions = uploaderVC.options;
				optionsVC.url = StaticUrls._vcCandidato(response.text());
				uploaderVC.setOptions(optionsVC);
				uploaderVC.uploadAll();

				return true;
			});
	}

	post(candidato: Collaboratore) {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.post(StaticUrls._collaboratore, JSON.stringify(candidato), this.optionsHeader)
					.map((response: Response) => { })
					.catch(this.handleError);
			}
		}
	}

	uploadContratto(id: number, uploader: FileUploader) {
		if(this.ifTokenNotExpired())
		{
			let options: FileUploaderOptions = uploader.options;
			options.url = StaticUrls._collaboratoreUploadContratto(id);
			if (this.myCookieService.token) {
				options.authToken = localStorage.getItem(environment.tokenName);
			}
			options.authTokenHeader = environment.headerName;
			uploader.setOptions(options);
			uploader.uploadAll();

			uploader.onCompleteAll;
		}
	}

	uploadCv(id: any, uploader: FileUploader) {
		if(this.ifTokenNotExpired())
		{
			let options: FileUploaderOptions = uploader.options;
			options.url = StaticUrls._cvCandidato(id);
			if (this.myCookieService.token) {
				options.authToken = localStorage.getItem(environment.tokenName);
			}
			options.authTokenHeader = environment.headerName;
			uploader.setOptions(options);
			uploader.uploadAll();

			uploader.onCompleteAll;
		}
	}

	uploadVc(id: any, uploader: FileUploader) {
		if(this.ifTokenNotExpired())
		{
			let options: FileUploaderOptions = uploader.options;
			options.url = StaticUrls._vcCandidato(id);
			if (this.myCookieService.token) {
				options.authToken = localStorage.getItem(environment.tokenName);
			}
			options.authTokenHeader = environment.headerName;
			uploader.setOptions(options);
			uploader.uploadAll();

			uploader.onCompleteAll;
		}
	}

	invioMailUpdateStato(messaggio: Messaggio, id: number, stato: string) {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.post(StaticUrls._collaboratoreUpdateStato(id, stato), JSON.stringify(messaggio), this.optionsHeader)
					.map((response: Response) => { })
					.catch(this.handleError);
			}
		}
	}

	search(collaboratore: Profilo): Observable<Profilo[]> {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.post(StaticUrls._searchCollaboratore, JSON.stringify(collaboratore), this.optionsHeader)
					.map(this.handleDataProfilo)
					.catch(this.handleError);
			}
		}
	}

	getXls(collaboratore: Collaboratore) {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				const optionsHeaderBlob = new RequestOptions({ responseType: ResponseContentType.Blob, headers: this.headers } );
				return this.http.get(StaticUrls._searchCollaboratoreXls(collaboratore.idStato, collaboratore.idTipologiaPosizione), optionsHeaderBlob)
					.map(res => {
						if(res.status === 204){
							return res;
						} else {
							return { filename: 'elenco-collaboratori.xls', data: res.blob() };
						}
					}).catch(this.handleError);
			}
		}
	}

	getById(id: number): Observable<Collaboratore> {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.get(StaticUrls._collaboratoreById(id), this.optionsHeader)
					.map(this.handleDataObj)
					.catch(this.handleError);
			}
		}
	}

	getCountNuovi(): Observable<number> {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.get(StaticUrls._countCollaboratoriNuovi, this.optionsHeader)
					.map(result => { return result.json(); })
					.catch(this.handleError);
			}
		}
	}

	getCountDaConfermare(): Observable<number> {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.get(StaticUrls._countCollaboratoriDaConfermare, this.optionsHeader)
					.map(result => { return result.json(); })
					.catch(this.handleError);
			}
		}
	}

	setStatoConfermato(id: number) {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.post(StaticUrls._collaboratoreSetConfermato(id), this.optionsHeader)
					.map((response: Response) => { })
					.catch(this.handleError);
			}
		}
	}

	delete(id: number){
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				return this.http.delete(StaticUrls._delete(id), this.optionsHeader)
					.map((response: Response) => { return response; });
			}
		}
	}

	private handleData(res: Response) {
		this.collaboratori = res.json();
		return this.collaboratori;
	}

	private handleDataProfilo(res: Response) {
		this.profili = res.json();
		return this.profili;
	}

	private handleDataObj(res: Response) {
		this.collaborator = res.json();
		return this.collaborator;
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

	private ifTokenNotExpired() {
		if (this.myCookieService.token) {
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/collaboratore.service.ts